<template>
    <div>

    </div>

</template>
<script>

export default {
    mixins: [],
    name: "initPage",
    components: {

    },
    data() {
        return {

        };
    },
    created() {
        this.handleAfterInit()
    },
    async beforeMount() {},
    mounted() {


    },
    methods: {
        handleAfterInit() {
            this.$router.replace("/main");
        },
    },
};
</script>
<style lang="scss"></style>
